import { createBrowserHistory } from 'history';
import { action, autorun, computed, observable } from 'mobx';
import * as React from 'react';

export declare interface IRoute {

   id: string;

   render(): React.ReactElement<any>;

   getPath(): string;

}

export declare interface IRouteStore {

  currentRoute: IRoute;

  navigate(routeId: string): void;

}

class RouteStore implements IRouteStore {

  private readonly routes: {[key:string]: IRoute};
  @observable private current: IRoute;

  constructor(routes: IRoute[]) {
    const routesMap: {[key:string]: IRoute} = {};
    routes.forEach(route => {
      routesMap[route.id] = route;
    });
    this.routes = routesMap;
  }

  @computed get currentRoute() {
    return this.current;
  }

  @action public navigate(path: string): void {
    if (path in this.routes) {
      this.current = this.routes[path];
    } else {
      throw new Error(`unregistered route with id ${path}`);
    }
  }

}

function bindRouterWithHistory(router: IRouteStore) {
  const history = createBrowserHistory({ basename: '/' });

  autorun(() => {
    if (router.currentRoute) {
      const path = router.currentRoute.getPath();
      if (path !== window.location.pathname) {
        history.push(path);
      }
    }
  });
}

export function createRouteStore(routes: IRoute[]): IRouteStore {
  const routerStore = new RouteStore(routes);

  bindRouterWithHistory(routerStore);

  return routerStore;
}



// WEBPACK FOOTER //
// ./src/RouteStore.ts